
import Vue from 'vue';

export default Vue.extend({
	name: 'ComplexBackgroundXS',
	props: {
		includeLeftBlobs: { type: Boolean, default: false },
	},
	data () {
		return {};
	},
});
